import { gql } from '@apollo/client';
import { AssignmentStatus } from '../../../../types/assignment';

export const GET_JOB_IDS = gql`
  query GetJobIds(
    $where: JSON
    $orderBy: [ColumnOrder]
    $limit: Int
    $offset: Int
  ) {
    jobs(
      where: $where
      orderBy: $orderBy
      limit: $limit
      offset: $offset
      groupBy: ["id"]
    ) {
      id
    }
  }
`;

export const GET_JOBS = gql`
  query GetJobs(
    $where: JSON
    $orderBy: [ColumnOrder]
    $limit: Int
    $offset: Int
  ) {
    jobs(where: $where, orderBy: $orderBy, limit: $limit, offset: $offset) {
      id
      #      status
      created

      recycledWaterInspection {
        waterSite {
          id
          name
        }
        supervisor {
          id
          name
          phones {
            id
            value
          }
        }
        contact {
          id
          name
          phones {
            id
            value
          }
        }
      }

      #      child {
      #        id
      #        vendorProfile {
      #          id
      #          name
      #        }
      #      }

      address {
        id
        street1
        street2
        city
        state
        zip
        zipExt
      }

      attachments {
        id
      }
    }
  }
`;

export type JobItem = {
  id: string;
  jobId: string;
  status?: AssignmentStatus;
  created: number;

  recycledWaterInspection: {
    waterSite: {
      id: string;
      name: string;
    };
    contact: {
      id: string;
      name: string;
      phones: {
        id: string;
        value: string;
      }[];
    };
    supervisor: {
      id: string;
      name: string;
      phones: {
        id: string;
        value: string;
      }[];
    };
  };

  child?: {
    vendorProfile: {
      name: string;
    };
  };

  address: {
    id: string;
    street1: string;
    street2?: string;
    city: string;
    state: string;
    zip: string;
    zipExt?: string;
  };

  attachments?: {
    id: string;
    type?: string;
    contentType?: string;
    url?: string;
    thumb?: string;
    profile?: {
      id: string;
      name: string;
    };
    created?: number;
  }[];
};
